import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { BaseModal } from "../../../../../models/basics/basics.models";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { RoleModel, GetRolesRequest } from "../../../../../models/manage/roles.models";
import { CustomerRoles } from "../steps/roles/roles";
import { CloneHelper } from "@rightship-tech/common-ui/helpers/clone.helper";
import { PLATFORM, autoinject } from "aurelia-framework";
import { PermissionEntity } from "../../../../../models/manage/permissions.models";
import { CustomerService } from "../../../../../services/modules/customer-client.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { ManageRolesClientService } from "../../../../../services/manage/manage-roles.service";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { I18N } from "aurelia-i18n";
import { ValidationsClientService } from "../../../../../services/validations/validations-client.service";
import { Guid } from "../../../../../utilities/guid";

@autoinject
export class RoleDialog extends BaseModal {
    dataModel: RoleModel;
    view: CustomerRoles;
    hasAddPermission: boolean;
    title: string;

    /**
     *
     */
    constructor(dialogClient: DialogClientService, private customerService: CustomerService, private notificationService: NotificationClientService,
        private manageRolesClientService: ManageRolesClientService, userClaimsService: UserClaimsService, private i18N: I18N,
        private validationsClientService: ValidationsClientService) {
        super(dialogClient);
        this.hasAddPermission = userClaimsService.hasPermission(Claims.CanAccessPermissions);
    }

    activate(args: {view: CustomerRoles, id: number}) {
        this.view = args.view;

        if (args.id) {
            this.title = "Edit Role";
            this.loadRole(args.id);
        }
        else {
            this.title = "New Role";
            this.dataModel = <RoleModel>{
                identifier: Guid.generateGuid(),
                entityType: EntityTypes.Role,
            };
        }

    }

    loadRole(id: number) {
        return new Promise<void>((resolve) => {
            this.manageRolesClientService.getRoles(<GetRolesRequest>{ roleId: id }).then(x => {
                this.dataModel = CloneHelper.clone(x.roles[0]);
                resolve();
            });
        });
    }

    onCancel(): Promise<void> {
        return new Promise((resolve) => {
            this.hideModal();
            resolve();
        });
    }

    openPermission() {
        this.dialogClient.show(PLATFORM.moduleName("views/pages/modules/customers/dialogs/permissions-dialog"), {
            type: PermissionEntity.Role,
            id: this.dataModel.roleId,
            showCloseButton: true,
            cancelOperation: () => { this.dialogClient.hide(); },
            afterSaveOperation: () => { this.dialogClient.hide(); this.hideModal(); },
         }, true, false, false, 'right');
    }

    public saveRole () {
        const initialId = this.dataModel.roleId;
        this.customerService.saveRole(this.dataModel, this.view.branchId).then(x => {
            if (!initialId) {
                this.loadRole(x.generatedId).then(() => {
                    this.view.reload();
                    this.notificationService.show(this.i18N.tr('changes-saved-successfully-text'), "", NotificationType.Success, 3000);
                    if (this.hasAddPermission) {
                        this.openPermission();
                    }
                });
            }
            else {
                this.view.reload();
                this.notificationService.show(this.i18N.tr('changes-saved-successfully-text'), "", NotificationType.Success, 3000);
                this.dialogClient.hide();
            }
        }).catch(err => {
            if (err.validationResult && err.validationResult.hasError) {
                this.validationsClientService.showValidationErrors(err.validationResult);
            } else {
                this.notificationService.show(this.i18N.tr('error-updating-text'), '', NotificationType.Error, 3000);
            }
            //else it is already handled
        })
    }

    close(){
        this.dialogClient.hide();
    }

    public toggleRoleLock() {
        this.dataModel.isLocked = !this.dataModel.isLocked;
    }
}